import React, { useEffect, useState } from 'react';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { addContributionApi, updateContributionApi, } from '../apiService';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { useDispatch, useSelector } from 'react-redux';
import { getLesseeApi, getOwnerLessorApi } from '../../../../shared_elements/actionCreators';
import { trackActivity } from '../../../../utils/mixpanel';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { formatBytes } from '../../../../utils/fileUpload';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';


const ContributionCRU = ({ addEditContribution, modeType, fileUpload, onToggleModal, getResponseBack, onOpenAttachments }) => {
    const { lessee, lessor, } = useSelector((state) => state.leases);
    const dispatch = useDispatch()
    const { storageDetails } = useSelector((state) => state.leases);
    const params = useParams()
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(addEditContribution?.data);
    const [error, setError] = useState({});
    const [attachments, setAttachments] = useState([]);

    useEffect(() => {
        if (!lessee?.length) {
            dispatch(getLesseeApi({}));
        }
        if (!lessor?.length) {
            dispatch(getOwnerLessorApi({}));
        }
    }, [dispatch]);

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({attachments:files}))
    };

    const onAddEditContribution = () => {
        const validationInputs = {
            component: data?.component ? "" : "Please enter Component",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data.id) {
                globalPutService(updateContributionApi({ ...params, slug: data?.slug }), data).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Contribution`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Contribution`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                });
            } else {
                const { lessee, lessor, ...cleanedData } = data
                globalPostService(addContributionApi(params), { ...cleanedData, lessee_id: data?.lessee, lessor_id: data?.lessor }).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Contribution`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Contribution`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Contribution`, error_msg: validationInputs, })
        }
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Contribution`, page_type: page_type, })
    }

    return (
        <>

            <Dialog
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onToggleModal();
                    }
                }}
                disableEscapeKeyDown
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? "Add Contribution" : modeType === 'edit' ? 'Edit Contribution' : 'View Contribution'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="component"
                                label="Component"
                                variant="outlined"
                                size='small'
                                value={data?.component || ''}
                                error={Boolean(error.component)}
                                helperText={error.component}
                                fullWidth
                                required
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("component", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("component")}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: { maxLength: 255 } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                         <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="party"
                                label="Party"
                                variant="outlined"
                                size='small'
                                value={data?.party || ''}
                                error={Boolean(error.party)}
                                helperText={error.party}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("party", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("party")}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: { maxLength: 255 } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="type"
                                label="Type"
                                variant="outlined"
                                size='small'
                                value={data?.type || ''}
                                error={Boolean(error.type)}
                                helperText={error.party}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("type", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("type")}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: { maxLength: 255 } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="event"
                                label="Event"
                                variant="outlined"
                                size='small'
                                value={data?.event || ''}
                                error={Boolean(error.event)}
                                helperText={error.event}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("event", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("event")}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: { maxLength: 255 } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="partly_estimated"
                                label="Partly Estimated"
                                variant="outlined"
                                size='small'
                                value={data?.partly_estimated || ''}
                                error={Boolean(error.partly_estimated)}
                                helperText={error.partly_estimated}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("partly_estimated", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("partly_estimated")}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: { maxLength: 255 } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="estimated_occurrence"
                                label="Estimated Occurrence"
                                variant="outlined"
                                size='small'
                                value={data?.estimated_occurrence || ''}
                                error={Boolean(error.estimated_occurrence)}
                                helperText={error.estimated_occurrence}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("estimated_occurrence", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("estimated_occurrence")}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: { maxLength: 255 } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="completed"
                                label="Completed"
                                variant="outlined"
                                size='small'
                                value={data?.completed || ''}
                                error={Boolean(error.completed)}
                                helperText={error.completed}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("completed", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("completed")}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: { maxLength: 255 } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="reference"
                                label="Reference"
                                variant="outlined"
                                size='small'
                                value={data?.reference || ''}
                                error={Boolean(error.reference)}
                                helperText={error.reference}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("reference", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("reference")}
                                slotProps={{ inputLabel: { shrink: true, }, htmlInput: { maxLength: 255 } }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Description' value={data?.description || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id="description"
                                    label="Description"
                                    variant="outlined"
                                    size='small'
                                    value={data?.description || ''}
                                    error={Boolean(error.description)}
                                    helperText={error.description}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    // onChange={(e) => onFieldChange("description", e.target.value.trimStart())}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("description", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, description: "" }));
                                    }} 
                                    onFocus={() => onRestErrorKey("description")}
                                    slotProps={{ inputLabel: { shrink: true, } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{mt: 3}}>
                           <Box className="responsive-buttons">
                            {data?.id && data?.attachments?.length ?
                                <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({addEditContribution?.data?.attachments?.length})Attachment(s)</Button> : null
                            }
                             <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                           </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                    <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditContribution() }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
        </>

    )
}
export default ContributionCRU;